import React from 'react';
import { Camera, MapPin, Users, Bell, Share } from 'lucide-react';

const features = [
  {
    icon: Camera,
    title: 'Record & Verify',
    description:
      'Record your tee shot with our built-in camera. Smart zoom helps you frame the green perfectly.',
  },
  {
    icon: Share,
    title: 'One-Tap Posting',
    description:
      'Record your shot and post it to your feed with a single tap. It\'s that easy.',
  },
  {
    icon: MapPin,
    title: 'Browse Courses & Prizes',
    description:
      'See nearby courses and what prizes are on the line at each par-3 hole.',
  },
  {
    icon: Users,
    title: 'Follow Friends & Golfers',
    description:
      'Follow your friends and other golfers to see their shots, aces, and rounds in your feed.',
  },
  {
    icon: Bell,
    title: 'Course Alerts',
    description:
      'Get notified when you\'re near a course with active prizes so you never miss a chance.',
  },
  {
    icon: MapPin,
    title: 'Follow Courses',
    description:
      'Follow your favorite courses to see every shot on their par 3s.',
  },
];

const Features: React.FC = () => {
  return (
    <section className="py-28 sm:py-36 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            App Features
          </h2>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex flex-col items-center text-center p-6 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow"
            >
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center mb-5"
                style={{ backgroundColor: '#9CB75A15' }}
              >
                <feature.icon size={26} style={{ color: '#9CB75A' }} strokeWidth={1.8} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
